module.exports = "../../static/fonts/WorkSans-Regular.92bbabf.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/WorkSans-Regular.ttf
// module id = 923
// module chunks = 2